import { render } from "./CommonFooter.vue?vue&type=template&id=199d3af4&scoped=true&ts=true"
import script from "./CommonFooter.vue?vue&type=script&lang=ts"
export * from "./CommonFooter.vue?vue&type=script&lang=ts"

import "./CommonFooter.vue?vue&type=style&index=0&id=199d3af4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199d3af4"]])

export default __exports__